import { chartConfig } from "../chart.commonConfig";
import { PATHS, PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";
import { CATEGORY_LIMIT } from "../chartHelper";

export const COSTOVERRUN_PIE_CHART_RESPONSIVE_HELPER = (
  data,
  history,
  checkedValue,
  user
) => {
  const PieChartConfig = {
    chart: {
      ...chartConfig.chart,
      type: "pie",
      //height: 400,
      height: (12 / 16) * 100 + "%",
      animation: {
        duration: 9000
      },
      className: "chart-background second-pie-graph",
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.SECOND_PAGE.SECOND._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      align: "center",
      text: "",
      useHTML: true,
      style: { color: "#000000", fontSize: "26px", "font-family": "mpb" },
      verticalAlign: "middle",
      y: 10
    },
    plotOptions: {
      series: {
        animation: true,
        duration: 9000
      },
      pie: {
        allowPointSelect: true,
        shadow: true,
        dataLabels: {
          enabled: true,
          //alignTo: "plotEdges",
          distance: -30,
          style: {
            color: "white"
          },
          className: "data-label-text"
        },
        showInLegend: true,
        point: {
          events: {
            legendItemClick: function() {
              this.slice(null);
              return false;
            },
            click: function(event) {
              history.push({
                pathname: PATHS.PROJECT_LIST,
                isDashBoard: true,
                summaryDataBy: false,
                state: {
                  groupCategory: "CENTRAL",
                  sponsoringMinistry:
                    user.groupCategory === "CENTRAL"
                      ? [
                          {
                            displayName: user.groupName,
                            key: user.groupId.toString()
                          }
                        ]
                      : null,
                  projectStage: [
                    {
                      displayName: "VERIFIED",
                      key: "VERIFIED"
                    }
                  ],
                  projectFlags: checkedValue
                    ? [
                        {
                          displayName: "MARCH 24",
                          key: "MARCH 24"
                        }
                      ]
                    : null,
                  costOverRun: [{ key: this.filter, displayName: this.name }],
                  projectTags: [
                    {
                      displayName: "NOT COMMISSIONED",
                      key: "NOT COMMISSIONED"
                    }
                  ]
                }
              });
            }
          }
        }
      }
    },
    series: [
      {
        name: "Issues",
        // colorByPoint: true,
        data: [],
        startAngle: 90,
        size: "100%",
        innerSize: "50%",
        //depth: 50,
        dataLabels: {
          enabled: true,
          alignTo: "connectors",
          format: `<span style="color:{point.color}">{point.y}</span>`
        }
      }
    ],
    legend: {
      enabled: false,
      align: "left",
      verticalAlign: "bottom",
      layout: "horizontal",
      floating: true,
      symbolHeight: 8,
      symbolWidth: 8,
      symbolRadius: 4,
      padding: 1,
      itemMarginTop: 0,
      itemMarginBottom: 1,
      //itemWidth: 200,
      margin: 1,
      itemStyle: {
        lineHeight: "18px",
        color: "#2E384D",
        "font-family": "mpr",
        fontSize: "11px",
        fontWeight: "300",
        textOverflow: "clip"
      }
    },
    tooltip: {
      formatter: function() {
        return `
                <b>${this.key}</b><br />
                <b>Projects: ${this.y}</b>
              `;
      }
    }
  };

  try {
    // set data
    let totalProjectsCount = 0;
    PieChartConfig.series[0]["data"] = (data || []).map((val, index) => {
      totalProjectsCount = totalProjectsCount + val.projectCount;
      return { name: val.key, y: val.projectCount, filter: val.filter };
    });
    PieChartConfig.title.text = `${totalProjectsCount}`;
    return PieChartConfig;
  } catch (error) {
    console.error(error);
  }
};
